import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { votePollRequested } from 'features/polls/actions';

export function* votePollSaga(action: ReturnType<typeof votePollRequested>) {
  yield call(SignalingSocket.send, { event: 'votePoll', data: action.payload });
}
